import { Dispatch } from "redux"

import {
    QidDatapoint,
    QidModelFailureMode,
} from "server/models"
import { randomNumber } from "client/utils"
import {
    setQidDatapointNew,
    initQidDatapoint,
} from "client/store"


const randomIndex = () => (
    Number(`${Date.now()}${randomNumber(5)}`)
)

export const addNewDatapoint = (
    failureModes: readonly QidModelFailureMode[],
    newDatapoints: readonly QidDatapoint[],
    dispatch: Dispatch,
) => {
    const nestedDatapoints: QidDatapoint[] = []
    failureModes.forEach((failureMode) => {
        nestedDatapoints.push({
            ...initQidDatapoint,
            id: randomIndex(),
            datapointId: 1, // not null value - used only for correct display
            failureMode,
        })
    })

    const newDatapoint: QidDatapoint = {
        ...initQidDatapoint,
        id: randomIndex(),
        createdAt: new Date(),
        datapoints: nestedDatapoints,
    }

    const newDatapointsCopy = newDatapoints.slice()
    newDatapointsCopy.unshift(newDatapoint)
    dispatch(setQidDatapointNew(newDatapointsCopy))
}

export const setRandomIndexes = (originDatapoints: readonly QidDatapoint[]) => {
    const updatedDatapoints: QidDatapoint[] = []
    originDatapoints.forEach((datapoint) => {
        const nestedDatapoints: QidDatapoint[] = []
        datapoint.datapoints.forEach((nested) => {
            nestedDatapoints.push({
                ...nested,
                id: randomIndex(),
            })
        })
        updatedDatapoints.push({
            ...datapoint,
            id: randomIndex(),
            datapoints: nestedDatapoints,
        })
    })
    return updatedDatapoints
}

export const clearFailureModes = (originDatapoints: readonly QidDatapoint[]) => {
    const updatedDatapoints: QidDatapoint[] = []
    originDatapoints.forEach((datapoint) => {
        const nestedDatapoints: QidDatapoint[] = []
        datapoint.datapoints.forEach((nested) => {
            nestedDatapoints.push({
                ...nested,
                failureMode: null,
            })
        })
        updatedDatapoints.push({
            ...datapoint,
            datapoints: nestedDatapoints,
        })
    })
    return updatedDatapoints
}

export const addNestedDatapoints = (
    originDatapoints: readonly QidDatapoint[],
    failureModes: readonly QidModelFailureMode[],
) => {
    const updatedDatapoints: QidDatapoint[] = []
    originDatapoints.forEach((datapoint) => {
        const nestedDatapoints: QidDatapoint[] = []
        const maxLength = Math.max(
            failureModes.length,
            datapoint.datapoints.length,
        )

        for (let i = 0; i < maxLength; i++) {
            const failureMode = failureModes[i] || null
            const nested = datapoint.datapoints[i] || {
                ...initQidDatapoint,
                id: randomIndex(),
                datapointId: 1, // not null value - used only for correct display
            }

            nestedDatapoints.push({
                ...nested,
                failureMode,
            })
        }

        updatedDatapoints.push({
            ...datapoint,
            datapoints: nestedDatapoints,
        })
    })
    return updatedDatapoints
}
